import styled from "styled-components";

/* 
    This is a styled component that is used to create a chapter.
    we use break-inside avoid to prevent the chapter from being split into multiple pages
    if that is possible. It's not enforced by the browser, but it's a good hint.
*/

export const Chapter = styled.section`
  break-inside: auto;
`;
